import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import BuyerBidList from '../components/DashboardComponents/BuyerBidList';
const BuyerBid = () => {
 return (
    <>
<InnerBanner pageKey="buyerBid" />

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <BuyerBidList/> 
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default BuyerBid;